import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const GoogleScaleMediumAppearanceDefault = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M21.8824 10.4588L21.7794 10.0308H12.2941V13.9692H17.9608C17.3726 16.7103 14.6422 18.1529 12.4118 18.1529C10.7892 18.1529 9.07843 17.4845 7.94608 16.4073C6.78431 15.3013 6.04412 13.6711 6.04412 11.9928C6.04412 10.3337 6.80392 8.67468 7.91177 7.58307C9.01471 6.49627 10.6863 5.88074 12.348 5.88074C14.25 5.88074 15.6127 6.87136 16.1226 7.3234L18.9755 4.53907C18.1373 3.81774 15.8382 2 12.2549 2C9.4902 2 6.83824 3.03871 4.90196 4.9334C2.9902 6.79923 2 9.49699 2 11.9976C2 14.4982 2.93627 17.0661 4.78922 18.9464C6.76961 20.9517 9.57353 22 12.4608 22C15.0882 22 17.5784 20.9901 19.3529 19.158C21.098 17.3547 22 14.8589 22 12.2428C22 11.1416 21.8873 10.4876 21.8824 10.4588Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Google'
);
export default GoogleScaleMediumAppearanceDefault;
